/**
 * Guards against an open redirect: `returnTo` round-trips through the OIDC
 * `state`, which is attacker-reachable (a crafted deep link into the sign-in
 * flow), so it must be a same-document path before anything navigates there.
 *
 * Only a path starting with a single `/` qualifies — `//evil.com` and
 * `https://evil.com` are both browser-parsed as a different origin, and a
 * bare `evil.com` is relative to the current path rather than the origin, so
 * none of them land where this guard intends "safe" to mean. A leading
 * backslash is rejected too: browsers normalize `\` to `/` in a URL, so
 * `/\evil.com` is the `//evil.com` case in disguise.
 */
export function isSafeReturnTo(value: string | undefined): value is string {
  return (
    typeof value === 'string' &&
    value.startsWith('/') &&
    !/^[/\\]/.test(value[1] ?? '')
  );
}
